import { Api } from 'utils';

class PaymentService {
		
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/payments/',params),
		download: async (params?: any) => Api.createResponse('admin/payments/download',params),
		partials: {
			get: async (params?: any) => Api.createResponse('admin/partial-payments/',params),
			download: async (params?: any) => Api.createResponse('admin/partial-payments/download',params)
		},
		bank: {
			get: async (params?: any) => Api.createResponse('admin/bank-payments/',params),
			download: async (params?: any) => Api.createResponse('admin/bank-payments/download',params),
			refund: async (params?: any) => Api.createResponse('admin/bank-payments/refund',params)
		}
	}

}

export default PaymentService;